define(function() {
  var $button = $(".js-confirm-modal-button");

  function init() {
    $button.on("click", changeLink);
  }

  function changeLink(event) {
    var $el = $(event.currentTarget);
    var data = $el.data();
    var $modal = $(data.target);
    var $submitButton = $modal.find(".js-confirm-modal-submit");
    var $msg = $modal.find(".js-confirm-modal-msg");

    if (data.msg) {
      $msg.text(data.msg);
    }

    $submitButton.attr({
      href: data.href,
      'data-method': data.method
    });
  }

  return init;
});
